<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/5_Itinerari-esperienze/5d_Arte-spiritualita_Taverna.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Storia, arte e spiritualità</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Esperienze e itinerari</a> > <a class="active">Storia, arte e spiritualità</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            La Calabria è una terra ricca di risorse naturali e perciò abitata sin da tempi remoti e da sempre crocevia di popoli diversi 
            che qui hanno lasciato segni evidenti tanto nel paesaggio quanto nella lingua, nell’arte, nella cultura e nelle espressioni tangibili della fede. 
            Una storia di ibridazioni che si può toccare con mano attraversando la regione sia nell’area montana e collinare interna, che lungo gli oltre 800 km di costa.
             Sono tanti gli itinerari tematici che possono letteralmente conquistare gli amanti del viaggio culturale: la storia si esprime appieno nei borghi e 
             nelle antiche città in cui si ritrovano monumenti, aree archeologiche e Musei che rendono palpabile una storia antichissima che parte dalle origini 
             dell’avventura umana, si pensi alla Grotta del Romito di Papasidero, passando per l’epoca magnogreca con le tante città che popolavano la costa Jonica, 
             da Sibari a Locri Epizefiri, una storia che i Bronzi di Riace esposti nel Museo Di Reggio Calabria incarnano pienamente. Un avvicendarsi di popoli e culture 
             che ben si evince nella greca Skylletion sul Golfo di Squillace, divenuta Scolacium in epoca romana e poi fortificata in età bizantina e normanna. 
             Il tracciato dell’immigrazione basiliana che interessa la Calabria a partire dal VII sec. è documentato dalla presenza di eremi, laure, cenobi, 
             monasteri e chiese, prima fra tutte la Cattolica di Stilo, vero e proprio monumento simbolo della Calabria bizantina, 
             un percorso tracciato su oltre mille chilometri di cammini. Ma vi sono molte altre tappe importanti per chi desidera entrare in contatto con la fede e 
             la spiritualità che la Calabria esprime un po’ ovunque, dalle Chiese e luoghi di culto di rito greco, si pensi all’area arbëreshe a Lungro, Acquaformosa, ecc..., 
             ai santuari, ai monasteri e alle chiese legati alle vite di San Nilo da Rossano, San Bruno, Gioacchino da Fiore, San Francesco Da Paola, 
             senza dimenticare i tanti santuari mariani che disegnano percorsi di fede e natura davvero unici. 
            <br>
            <br>
            Del processo di fortificazione che si intensifica nelle epoche sveve, angioine e aragonesi testimoniano i tanti castelli e le torri che si
             incontrano sulla costa e nelle aree interne, si pensi a Rocca Imperiale, Roseto Capo Spulico, alla fortezza delle Castella nell’area marina 
             protetta di Capo Rizzuto, a Santa Severina a Pizzo, Scilla, un elenco lunghissimo che comprende anche le città, Cosenza, Catanzaro, Vibo Valentia, 
             Reggio Calabria, ecc...
            <br>
            <br>
            Se chiese, conventi, monasteri e santuari custodiscono la parte più consistente del patrimonio artistico calabrese, tra cui si segnala 
            la produzione del celebre pittore di Taverna Mattia Preti, e quella dello scultore Antonello Gagini, che ha fatto parlare di Rinascimento in Aspromonte, 
            tante sono le pinacoteche, le gallerie civiche e i Musei diffusi che raccontano storia, arte, arte sacra, industria, paesaggio e tradizioni.
             Molti sono anche gli allestimenti site specific che riguardano l’arte contemporanea che delineano un vero e proprio percorso per gli appassionati, 
             che va dal Museo all’aperto Bilotti di Cosenza al Parco internazionale della scultura Catanzaro e alle statue monumentali di Rabarama sul lungomare 
             Falcomatà di Reggio Calabria; progetti a cui fanno eco il Mabos Museo d’arte contemporanea nel Bosco della Sila e il Musaba di Mammola nel complesso monumentale 
             di Santa Barbara.
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>